module.exports = __webpack_public_path__ + "static/img/earth2.81ea9513.png";